import Instance from "../general.instance";
import {
  RESET_PASSWORD,
  AUTH_ME,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_EXTERNAL,
  PASSWORD_VALIDATE_EXTERNAL,
  LOGIN,
  LOGOUT,
  REFRESH_TOKEN,
  AUTH_INSTANCE
} from "../constants";

const AuthInstance = new Instance(AUTH_INSTANCE);

const AuthService = {
  resetPassword(body) {
    return AuthInstance.post(RESET_PASSWORD, body);
  },
  changePassword(body) {
    return AuthInstance.put(CHANGE_PASSWORD, body);
  },
  changePasswordExternal(body) {
    return AuthInstance.put(CHANGE_PASSWORD_EXTERNAL, body);
  },
  validate(data, token) {
    return AuthInstance.post(PASSWORD_VALIDATE_EXTERNAL, data, { ...token });
  },
  getAuthMe() {
    return AuthInstance.fetch(AUTH_ME);
  },
  updateAuthMe(body) {
    return AuthInstance.put(AUTH_ME, body);
  },
  login(body) {
    return AuthInstance.post(LOGIN, body);
  },
  logout(token) {
    let config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    return AuthInstance.create(LOGOUT, "", null, config);
  },
  refreshToken(params) {
    return AuthInstance.post(REFRESH_TOKEN, params);
  },
  cancelReq() {
    return AuthInstance.cancelRequest();
  }
};

export default AuthService;
